/**
 * Formátovanie ceny pre daily-menu obrazovku.
 *
 * Vráti "" (→ cena sa NEZOBRAZÍ), ak:
 *  - cena chýba (undefined / null / prázdny reťazec), alebo
 *  - cena je NULOVÁ — ošetrené sú všetky typy nuly: 0, -0, "0", "0.0",
 *    "0.00", "0,00", "0 €", " 0 " a pod. (po parse na číslo === 0).
 *
 * Nenumerickú, nenulovú hodnotu (napr. text) vráti nezmenenú, aby sa
 * neskrylo niečo, čo nie je nulová cena.
 *
 * @param {number|string|null|undefined} price
 * @returns {string} naformátovaná cena (napr. "4.50") alebo "" keď sa nemá zobraziť
 */
export function formatPrice(price) {
  if (price === undefined || price === null || price === "") return "";
  const num =
    typeof price === "number"
      ? price
      : parseFloat(String(price).replace(",", "."));
  if (Number.isNaN(num)) return String(price);
  // Nulová cena (ľubovoľného typu) sa nezobrazuje.
  if (num === 0) return "";
  return num.toFixed(2);
}

export default formatPrice;
